import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import withRouter from "../Components/Common/withRouter";

//redux
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useAppSelector } from "Components/Hooks/hooks";

// Auth pages that logged-in users should not access
const authPages = ["/login", "/register", "/forgot-password"];

const NonAuthLayout = ({ children }: any) => {
  const user = useAppSelector((state) => state?.auth?.user);
  const location = useLocation();

  const nonAuthData = createSelector(
    (state) => state.Layout,
    (layoutModeType) => layoutModeType.layoutModeType
  );
  // Inside your component
  const layoutModeType = useSelector(nonAuthData);

  useEffect(() => {
    if (layoutModeType === "dark") {
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.setAttribute("data-bs-theme", "light");
    }
    return () => {
      document.body.removeAttribute("data-bs-theme");
    };
  }, [layoutModeType]);

  // If user is logged in and trying to access auth pages, redirect to dashboard
  if (user?.access_token && authPages.includes(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <div>{children}</div>;
};

export default withRouter(NonAuthLayout);
